import { Navigate } from 'react-router';
import { GoogleSignInButton } from '../auth/GoogleSignInButton.js';
import { useAuth } from '../auth/AuthProvider.js';
import { Layout } from '../components/Layout.js';
import { LoadingScreen } from '../components/LoadingScreen.js';
import { es } from '../i18n/es.js';
import { tripDates, tripPlace } from '../lib/trip.js';

export function LoginPage() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (user) return <Navigate to="/" replace />;

  return (
    <Layout center>
      <section className="flex flex-col gap-10">
        <header className="flex flex-col gap-3">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-accent">
            {es.appName}
          </p>
          <h1 className="text-4xl font-semibold leading-none tracking-tight sm:text-5xl">
            {tripPlace}
          </h1>
          <p className="text-lg text-neutral-600 dark:text-neutral-400">{tripDates}</p>
        </header>

        <div className="flex flex-col gap-4">
          <h2 className="text-base font-medium">{es.login.title}</h2>
          <GoogleSignInButton />
          <p className="text-sm leading-relaxed text-neutral-500 dark:text-neutral-400">
            {es.login.onlyInvited}
          </p>
        </div>
      </section>
    </Layout>
  );
}
